import React from 'react';

import CenteredContainer from '@/common/CenteredContainer';

import HeroSection from './components/HeroSection/HeroSection';
import AdvisoryMessage from './components/AdvisoryMessage/AdvisoryMessage';
import StatesList from './components/StatesList/StatesList';

import { useStoreLocator } from './hooks/useStoreLocator';
import Loaders from './components/Loaders/Loaders';

export const StoreLocator = () => {
    const {
        data,
        isLoading,
        error,
        handleOpenLocalizationRail
    } = useStoreLocator();

    if (isLoading) {
        return <Loaders />
    }

    if (error || data === null) {
        return null;
    };

    const {
        heroSection,
        advisoryMessage,
        statesList
    } = data;

    return (
        <div data-testid="store-locator-page-container">
            <HeroSection heroSection={heroSection} handleOpenLocalizationRail={handleOpenLocalizationRail} />
            <CenteredContainer>
                <AdvisoryMessage advisoryMessage={advisoryMessage} />
                <StatesList statesList={statesList} />
            </CenteredContainer>
        </div>
    );
};

export default StoreLocator;